"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImageNode = exports.ImageFrame = void 0;
var Common_1 = require("./Common");
var ImageFrame;
(function (ImageFrame) {
    ImageFrame["None"] = "";
    ImageFrame["Circle"] = "circle";
})(ImageFrame = exports.ImageFrame || (exports.ImageFrame = {}));
var isImageNode = function (elem) {
    return elem.type === Common_1.BlockType.Image;
};
exports.isImageNode = isImageNode;
